import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FH110 + detail tables)
// ============================================================

export interface FH110 {
  fh110_01: string;          // 請款單號 (PK)
  fh110_11: string | null;   // 請款日期
  fh110_12: number;          // 請款金額
  fh110_13: number;          // 備用金額
  fh110_14: string;          // 旗標
  fh110_15: string;          // 受款人代號
  fh110_16: string;          // 公司代號
  fh110_17: string;          // 請款說明 (memo)
  fh110_18: string;          // 備註 (memo)
  fh110_181: string;         // 備註代號
  fh110_19: string | null;   // 支票到期日(1)
  fh110_20: string;          // 旗標2
  fh110_21: number;          // 已付款總額
  fh110_22: string;          // 請款類別
  fh110_23: string | null;   // 需要日期
  fh110_241: boolean;        // 布林旗標
  fh110_242: boolean;        // 取消禁背
  fh110_243: string;         // 備註3
  fh110_25: string;          // 幣別
  fh110_26: number;          // 匯率
  fh110_27: string;          // 票款別
  fh110_28: number;          // 總稅額
  fh110_29: string | null;   // 預計沖銷日
  fh110_30: string | null;   // 支票到期日(2)
  fh110_31: number;          // 票面金額(1)
  fh110_32: number;          // 票面金額(2)
  fh110_33: string;          // 備用代碼3
  fh110_34: number;          // 備用金額6
  fh110_35: boolean;         // 布林旗標3
  fh110_36: string;          // 旗標4
  fh110_37: string;          // 部門代號
  fh110_38: string;          // 旗標5
  fh110_39: number;          // 費用明細項數
  fh110_391: number;         // 請款明細項數
  fh110_392: number;         // 入庫請款項數
  fh110_40: string;          // 部門代碼
  fh110_41: string;          // 旗標6
  fh110_42: boolean;         // 暫不付款
  fh110_43: string;          // 取消理由 (memo)
  fh110_44: boolean;         // 無憑證
  fh110_45: string;          // 受款資料 (memo)
  fh110_46: string;          // 支票號碼(1)
  fh110_47: string;          // 支票號碼(2)
  fh110_48: number;          // 所得類別
  fh110_49: string | null;   // 備用日期5
  fh110_50: number;          // 備用整數3
  fh110_51: string;          // 旗標7
  fh110_52: string;          // 備用代碼7
  fh110_80: string;          // 核准狀態 (N/S/P/R)
  fh110_90: number;          // 版本號
  fh110_91: string;          // 修改人
  fh110_92: string | null;   // 修改時間
  fh110_93: string;          // 建立人

  // Detail associations
  expense_details?: FH111[];
  loan_offsets?: FH112[];
  invoice_details?: FH113[];
  prepaid_offsets?: FH114[];
  receipt_details?: FH116[];
  agent_offsets?: FH117[];
  anomaly_details?: FH118[];
  payment_offsets?: FH081[];
}

export interface FH111 {
  fh111_01: string;   // 請款單號 (FK)
  fh111_02: number;   // 明細序號
  fh111_03: number;   // 子序號
  fh111_11: string;   // 入庫單號/費用代碼
  fh111_12: string;   // 備用代碼1
  fh111_13: string;   // 備用代碼2
  fh111_14: string;   // 幣別
  fh111_15: number;   // 金額
  fh111_151: number;  // 備用金額
  fh111_16: number;   // 匯率
  fh111_17: string;   // 備用代碼3
  fh111_18: number;   // 備用金額2
  fh111_19: string;   // 備用代碼4
  fh111_20: string;   // 備用代碼5
  fh111_21: string | null; // 備用日期
  fh111_22: number;   // 備用金額3
  fh111_23: number;   // 備用金額4
  fh111_24: number;   // 備用金額5
  fh111_25: string;   // 扣款類別
  fh111_26: string;   // 備用代碼6
  fh111_27: string | null; // 備用日期2
  fh111_28: string;   // 客訴單號
  fh111_29: string;   // 備用代碼8
  fh111_30: number;   // 備用整數
  fh111_31: string;   // 備用代碼9
  fh111_32: string;   // 備用代碼10
  fh111_33: boolean;  // 布林旗標
  fh111_34: number;   // 備用整數2
  fh111_35: string | null; // 備用日期3
  fh111_36: number;   // 備用金額6
  fh111_37: string;   // 備用字串
  fh111_38: string;   // 備用代碼11
  fh111_39: string;   // 旗標2
  fh111_391: string;  // 旗標3
  fh111_392: string;  // 備用代碼12
  fh111_393: string;  // 備用代碼13
  fh111_40: number;   // 備用金額7
  fh111_41: number;   // 備用金額8
  fh111_42: string;   // 備用字串2
  fh111_43: number;   // 備用金額9
  fh111_90: number;   // 版本號
}

export interface FH112 {
  fh112_01: string;   // 請款單號 (FK)
  fh112_02: number;   // 明細序號
  fh112_11: string;   // 暫借款單號
  fh112_12: string;   // 幣別
  fh112_13: number;   // 沖帳金額
  fh112_14: number;   // 備用整數
  fh112_90: number;   // 版本號
}

export interface FH113 {
  fh113_01: string;        // 請款單號 (FK)
  fh113_02: number;        // 明細序號
  fh113_11: string;        // 發票號碼
  fh113_12: string | null; // 發票日期
  fh113_13: number;        // 發票淨額
  fh113_14: number;        // 發票稅額
  fh113_15: number;        // 發票總額
  fh113_16: number;        // 未稅請款金額
  fh113_17: number;        // 請款稅額
  fh113_18: number;        // 備用整數
  fh113_19: boolean;       // 布林旗標
  fh113_90: number;        // 版本號
  fh113_91: string;        // 修改人
  fh113_92: string | null; // 修改時間
  fh113_93: string;        // 建立人
}

export interface FH114 {
  fh114_01: string;   // 請款單號 (FK)
  fh114_02: number;   // 明細序號
  fh114_11: string;   // 預收款單號
  fh114_12: string;   // 幣別
  fh114_13: number;   // 沖帳金額
  fh114_14: number;   // 備用整數
  fh114_90: number;   // 版本號
}

export interface FH116 {
  fh116_01: string;        // 請款單號 (FK)
  fh116_02: number;        // 明細序號
  fh116_03: number;        // 子序號
  fh116_04: number;        // 子子序號
  fh116_05: string | null; // 備用日期
  fh116_11: number;        // 備用整數
  fh116_12: string;        // 備用代碼1
  fh116_13: string;        // 備用代碼2
  fh116_14: number;        // 數量1
  fh116_141: number;       // 數量2
  fh116_15: number;        // 數量3
  fh116_16: number;        // 數量4
  fh116_161: number;       // 數量5
  fh116_17: number;        // 單價
  fh116_18: number;        // 金額1
  fh116_19: number;        // 金額2
}

export interface FH117 {
  fh117_01: string;        // 請款單號 (FK)
  fh117_02: number;        // 明細序號
  fh117_11: string;        // 代墊款單號
  fh117_12: string;        // 幣別
  fh117_13: number;        // 沖帳金額
  fh117_14: number;        // 備用整數
  fh117_90: number;        // 版本號
}

export interface FH118 {
  fh118_01: string;        // 請款單號 (FK)
  fh118_02: number;        // 明細序號
  fh118_03: number;        // 子序號
  fh118_04: number;        // 子子序號
  fh118_11: string;        // 異常代碼
  fh118_12: string;        // 異常說明
  fh118_13: string;        // 備用代碼
}

export interface FH081 {
  fh081_01: string;        // 請款單號
  fh081_02: string;        // 付款序號
  fh081_03: string;        // 付款單號
  fh081_11: number;        // 付款金額
  fh081_12: string | null; // 沖帳單號/日期
}

// ============================================================
// Request / Response types
// ============================================================

export interface PWH201ListResponse {
  data: FH110[];
  total: number;
  page: number;
  size: number;
}

export interface PWH201CreateRequest {
  master: Partial<FH110>;
  expense_details: Partial<FH111>[];
  invoice_details: Partial<FH113>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

export interface ApprovalResponse {
  id: string;
  action: string;
  old_status: string;
  new_status: string;
  message: string;
}

export interface ApprovalHistory {
  id: number;
  document_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

// ============================================================
// API methods
// ============================================================

const BASE = '/api/pwh201';

export const pwh201Api = {
  async list(page = 1, size = 20): Promise<PWH201ListResponse> {
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FH110> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: PWH201CreateRequest): Promise<FH110> {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  async update(id: string, data: PWH201CreateRequest): Promise<FH110> {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },

  // Approval workflow
  async submitForApproval(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/submit`, { comment: comment || '' });
    return res.data;
  },

  async approve(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/approve`, { comment: comment || '' });
    return res.data;
  },

  async reject(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/reject`, { comment: comment || '' });
    return res.data;
  },

  async writeoff(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  async getApprovalHistory(id: string): Promise<ApprovalHistory[]> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}/approval-history`);
    return res.data.data || [];
  },

  // Lookup name resolution via shared lookup API
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};

export default pwh201Api;
